const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const Dashbaord = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "DASHBOARD_REQUEST":
      return { loading: true, error: false, data: [] };
    case "DASHBOARD_ERROR":
      return { loading: false, error: true, data: [] };
    case "DASHBOARD_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "DASHBOARD_RESET":
      return { loading: false, error: false, data: [] };
    default:
      return state;
  }
};

export default Dashbaord;
